import "@fancyapps/fancybox";
import "@fancyapps/fancybox/dist/jquery.fancybox.min.css";
import "air-datepicker/dist/css/datepicker.min.css";
import "air-datepicker/dist/js/datepicker.min.js";
import "font-awesome/css/font-awesome.css";
import "jquery-ui";
import "jquery-ui/ui/widgets/autocomplete";
import "jquery-ui/ui/widgets/selectmenu";
import "jquery-ui/ui/widgets/slider";

import $ from "jquery";
import {} from "jquery-ujs";

import "popper.js";
import "bootstrap/dist/js/bootstrap.min.js";

import "tooltipster";
import "tooltipster/dist/css/tooltipster.bundle.min.css";

import Honeybadger from "honeybadger-js";

import "../../components/desktop/searchfield/languages";
import "../../dep/jquery.resizeandcrop";
import "../../dep/gon";

import { Track } from "../../components/common/track";
import { Translation } from "../../components/common/translation";
import { logFunnelEvent } from "../../app/helpers/classes/funnel_tracking";

import Modal from './modal'

Honeybadger.configure({
  apiKey: "780ab0c8",
  environment: process.env.ENVIRONMENT || "development",
  revision: "master",
  disabled: !(process.env.HB_DISABLED === "false"),
  maxErrors: 100
});

Honeybadger.beforeNotify(function (notice) {
  if (/api.tiles.mapbox.com|cdn.livechatinc.com/.test(notice.stack)) {
    return false;
  }
});

// Wraps the existing (otherwise-bare) #alert-message flash content in a
// Tailwind dialog shell at runtime, instead of duplicating that content
// server-side just to have two markup shapes for one flash partial shared
// by every layout. Moves contentEl in place rather than cloning it, so
// its content (including any links/markup inside) stays exactly as
// rendered.
function showAlertMessageDialog(contentEl) {
  const backdrop = document.createElement("div");
  backdrop.className = "fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 p-4";

  const card = document.createElement("div");
  card.className = "w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-xl";

  const header = document.createElement("div");
  header.className = "flex items-center justify-end border-b border-gray-200 px-4 py-3";

  const closeBtn = document.createElement("button");
  closeBtn.type = "button";
  closeBtn.className = "text-gray-400 hover:text-gray-600";
  closeBtn.setAttribute("aria-label", "Stäng");
  closeBtn.innerHTML = '<svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>';

  const body = document.createElement("div");
  body.className = "p-6 text-sm text-gray-700";

  const close = () => backdrop.remove();
  closeBtn.addEventListener("click", close);
  backdrop.addEventListener("click", (event) => {
    if (event.target === backdrop) close();
  });

  header.appendChild(closeBtn);
  contentEl.style.display = "";
  body.appendChild(contentEl);
  card.appendChild(header);
  card.appendChild(body);
  backdrop.appendChild(card);
  document.body.appendChild(backdrop);
}
window.showAlertMessageDialog = showAlertMessageDialog;

$(document).ready(function() {
  Track.initialize();
  window.modal = new Modal()
  window.modal.init()

  if ($("#alert-message").length > 0) {
    logFunnelEvent("error_popup_shown", { message: $("#alert-message").text().trim() });

    // Rebuilt Tailwind pages (.tw-page) get a Tailwind dialog instead of
    // fancybox -- the site-wide fancybox replacement (see
    // step2_seating_fix memory). Not scoped to any single page: this
    // flash partial is shared by every layout, rebuilt or not, so the
    // branch has to happen here at runtime rather than in the (also
    // shared) markup itself.
    if (document.querySelector(".tw-page")) {
      showAlertMessageDialog(document.getElementById("alert-message"));
    } else {
      $.fancybox.open({ src: "#alert-message" });
    }
  }

  if ($(".languages").length > 0) {
    $(".languages").tooltipster({
      trigger: "custom",
      triggerOpen: {
        click: true
      },
      triggerClose: {
        click: true,
        scroll: true
      },
      contentAsHTML: true,
      placement: "auto",
      autoClose: false,
      content: $("#language_dropdown_window").html(),
      functionReady(instance, helper) {
        $(`#${instance.__namespace}`).addClass("tooltipster-clickable");
      }
    });
  }
});
